import { debounce } from "debounce";
import { defineComponent, createElement as h, computed } from '@vue/composition-api';
import { SearchFacet } from './abstractions';

export default defineComponent({
    name: "WokFacetedSearchBar",

    props: {
        facets: {
            type: Array,
            default: () => []
        },
        query: {
            type: Object,
            default: () => { }
        },
        debounceInterval: {
            type: Number,
            default: 500
        }
    },

    model: { prop: 'query', event: 'update:query' },

    setup(props, ctx) {

        const form = computed(() => {
            let o: any = {};
            for (let f of (props.facets as SearchFacet[])) {
                o[f.name] = props.query[f.name] || null;
            }
            return o;
        })

        const emitUpdateQuery = (name: string, value: any) => {
            form.value[name] = value;
            ctx.emit('update:query', form.value);
        }

        const emitUpdateQueryDebounced = computed(() => {
            if (props.debounceInterval > 0) {
                return debounce(emitUpdateQuery, props.debounceInterval);
            }
            else {
                return emitUpdateQuery;
            }
        })

        return () => {

            let facetsComponent = (props.facets as SearchFacet[]).map(x => {
                if (x.type == 'text') {
                    return h('WokInputText', {
                        props: {
                            value: form.value[x.name],
                            label: x.label
                        },
                        on: {
                            // Debounce events on text facets because the user usually wants
                            // to search with a string not just a single character.
                            ['update:value']: (evt: string) => emitUpdateQueryDebounced.value(x.name, evt)
                        }
                    })
                }
                if (x.type == 'single-choice') {
                    return h('WokSelectNative', {
                        props: {
                            value: form.value[x.name],
                            label: x.label,
                            options: x.options,
                            type: x.optionsType || 'string'
                        },
                        on: {
                            // Note that we don't debounce a single choice, no need for it.
                            ['update:value']: (evt: string) => emitUpdateQuery(x.name, evt)
                        }
                    })
                }
            })

            return h('WokForm', {}, [h('WokFormRow', {}, facetsComponent)])
        }
    }
})
